import { AiAgentsRoute } from '@/modules/ta/aiagent/aiagent.constants';

export const router = [
  {
    path: `/${AiAgentsRoute.AIAGENT}`,
    component: () => import(/* webpackChunkName: "aiagent-page" */ './pages/AiAgentsPage.vue'),
    props: true,
  },
];
